import { Link } from "react-router-dom";
import { mediaList, typeLabel, type MediaType } from "@/mocks/media";

const typeMeta: Record<MediaType, { icon: string; desc: string; accent: string }> = {
  movie: { icon: "ri-film-line", desc: "高清院线新片，悬疑、动作、爱情一网打尽", accent: "bg-accent-500" },
  tv: { icon: "ri-tv-2-line", desc: "热播剧集持续更新，追剧不用等", accent: "bg-primary-500" },
  variety: { icon: "ri-mic-line", desc: "真人秀、音乐、纪实，轻松下饭好选择", accent: "bg-secondary-500" },
};

const types: MediaType[] = ["movie", "tv", "variety"];

export default function CategoryQuickEntry() {
  return (
    <section aria-label="分类快捷入口" className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
        {types.map((type) => {
          const count = mediaList.filter((item) => item.type === type).length;
          return (
            <Link
              key={type}
              to={`/category/${type}`}
              className="group rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors p-4 md:p-5 flex items-center gap-4"
            >
              <div
                className={`w-11 h-11 md:w-12 md:h-12 shrink-0 rounded-md ${typeMeta[type].accent} text-background-50 flex items-center justify-center`}
              >
                <i className={`${typeMeta[type].icon} text-xl`}></i>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {typeLabel[type]}
                  </h3>
                  <span className="text-[11px] px-1.5 py-0.5 rounded bg-background-100 text-foreground-600">
                    {count} 部
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 truncate">{typeMeta[type].desc}</p>
              </div>
              <i className="ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}